var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRouteGuide(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 99,
    height: 99,
    rx: 11.5,
    fill: "#F8FBFF",
    stroke: "#EBF1FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.7137 75.9999C45.022 75.577 44.3348 74.2378 44.2026 73.6211H52.5286C52.5286 74.9955 51.0308 75.7797 50.2819 75.9999H46.7137Z",
    fill: "#1CB8DA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0028 42.4482C21.897 38.9592 24.8662 38.3513 26.364 38.4835L70.1085 39.1442C73.7084 39.1442 74.8662 40.4494 74.8662 42.8283V71.5231C74.2318 74.8006 71.5182 74.827 70.2406 74.4306C66.5402 73.1618 53.7208 73.9019 47.7737 74.4306C41.853 73.5848 31.0336 74.0781 26.364 74.4306C22.0292 74.4306 22.0027 72.4318 22.0028 70.8623V42.4482Z",
    fill: "#1CB8DA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6456 39.2844C24.5505 35.7883 27.2226 35.1791 28.5706 35.3116L67.9385 34.6521C71.1783 34.6521 72.2203 37.2816 72.2203 39.6653V68.4189C71.6494 71.7031 69.2072 71.7296 68.0575 71.3323C64.7273 70.061 53.1904 70.8026 47.8383 71.3323C42.5099 70.4847 32.773 70.9792 28.5706 71.3323C24.6694 71.3323 24.6456 69.3294 24.6456 67.7567V39.2844Z",
    fill: "#E1F4F1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7709 71.3745C47.4537 71.163 47.6388 71.1101 46.8458 71.1101L47.3745 34.8987H49.8855L49.0925 71.1101C48.696 71.1101 48.4317 71.3745 47.7709 71.3745Z",
    fill: "#BDBDBD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6079 48.618C31.3833 47.3405 38.1498 45.5519 43.0132 48.618",
    stroke: "#90A7C2",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6079 55.7547C31.3833 54.4772 38.1498 52.6886 43.0132 55.7547",
    stroke: "#90A7C2",
    strokeWidth: 1.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6079 63.1556C31.3833 61.8781 38.1498 60.0895 43.0132 63.1556",
    stroke: "#90A7C2",
    strokeWidth: 1.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3965 48.618C55.1718 47.3405 61.9383 45.5519 66.8018 48.618",
    stroke: "#90A7C2",
    strokeWidth: 1.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3965 55.7547C55.1718 54.4772 61.9383 52.6886 66.8018 55.7547",
    stroke: "#90A7C2",
    strokeWidth: 1.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3965 63.1556C55.1718 61.8781 61.9383 60.0895 66.8018 63.1556",
    stroke: "#90A7C2",
    strokeWidth: 1.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.2486 48.3764C58.5626 46.7322 64.0264 40.198 64.0264 32.3877C64.0264 23.337 56.6894 16 47.6388 16C38.5881 16 31.2511 23.337 31.2511 32.3877C31.2511 40.2944 36.8507 46.8934 44.3006 48.4351C44.3545 48.8355 44.4808 49.2376 44.6888 49.6262C46.0065 52.0875 49.5354 52.0875 50.853 49.6262C51.0712 49.2187 51.1995 48.7962 51.2486 48.3764Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3951 35.5992C38.2782 37.1777 39.5644 38.8391 40.2221 39.4725C40.4779 39.7188 40.5875 39.7404 40.7702 39.6552C42.6703 38.0182 43.0723 36.5858 43.0357 36.0742C43.0357 33.9403 41.4523 33.5042 40.6606 33.553C38.7605 33.4653 38.3586 34.8806 38.3951 35.5992Z",
    fill: "#F2453D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.5458 31.6499C51.4811 30.6266 49.3992 27.9423 49.5885 25.3918C49.5293 24.2307 50.1799 21.9439 53.2555 22.0856C54.537 22.0069 57.1001 22.7114 57.1001 26.1593C57.1592 26.9858 56.5086 29.3002 53.433 31.9451C53.1372 32.0829 52.9598 32.0479 52.5458 31.6499ZM53.34 27.5604C54.3289 27.5604 55.1305 26.7588 55.1305 25.7699C55.1305 24.7811 54.3289 23.9795 53.34 23.9795C52.3512 23.9795 51.5495 24.7811 51.5495 25.7699C51.5495 26.7588 52.3512 27.5604 53.34 27.5604Z",
    fill: "#F2453D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3035 32.3835C53.2247 32.3835 51.7074 32.4613 49.9283 32.554C48.1447 32.6469 47.2567 34.7575 48.4369 36.098V36.098C49.632 37.4554 48.7053 39.5912 46.8975 39.6456L40.5145 39.8377",
    stroke: "#1CB8DA"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRouteGuide);
export default __webpack_public_path__ + "static/media/route-guide.c7b551ab7b2d4e3b80c786e6899c610a.svg";
export { ForwardRef as ReactComponent };